import { resignationRequestProcessService } from '@/services/v2/resignation-request-process-service'
import * as _ from 'lodash'

const defaultRollbackPlan = () => ({
  _id: null,
  client: null,
  locale: null,

  name: null,

  rollbackPlanCreator: null,
  fiveWhy: {
    whyOne: null,
    whyTwo: null,
    whyThree: null,
    whyFour: null,
    whyFive: null
  },

  actions: [],

  expectedFollowDates: []
})

const defaultCollaborator = () => ({
  _id: null
})

const state = {
  rollbackPlan: defaultRollbackPlan(),
  storageRollbackPlan: defaultRollbackPlan(),

  collaboratorSelected: defaultCollaborator(),
  leadership: null,
  rollbackPlanCreator: null
}

const getters = {
  hasRollbackPlan: (state) => state.rollbackPlan._id != null
}

const mutations = {
  SET_ROLLBACK_PLAN: (state, rollbackPlan) => {
    state.storageRollbackPlan = _.cloneDeep(rollbackPlan)
    state.rollbackPlan = _.cloneDeep(rollbackPlan)
  },

  SET_COLLABORATOR: (state, collaborator) => {
    state.collaboratorSelected = collaborator
    state.leadership = collaborator.leadership
  },

  RESET_SELECTED_COLLABORATOR: (state) => {
    state.collaboratorSelected = defaultCollaborator()

    state.storageRollbackPlan = defaultRollbackPlan()
    state.rollbackPlan = defaultRollbackPlan()
  }
}

const actions = {
  async refresh({ dispatch, state }, rollbackPlanId) {
    if (!rollbackPlanId && state.rollbackPlan._id) {
      rollbackPlanId = state.rollbackPlan._id
    }
    if (!rollbackPlanId) {
      throw new Error('rollbackPlanId is required')
    }

    const { data: resignationRequestProcess } = await resignationRequestProcessService.getById(
      rollbackPlanId
    )
    if (!resignationRequestProcess) {
      throw new Error('rollbackPlan not found')
    }

    dispatch('load', { ...resignationRequestProcess.rollbackPlan, _id: resignationRequestProcess._id, rollbackPlanCreator: resignationRequestProcess.rollbackPlanCreator })
  },
  load({ commit }, rollbackPlan) {
    commit('SET_ROLLBACK_PLAN', rollbackPlan)
  },
  clear({ commit }) {
    commit('SET_ROLLBACK_PLAN', defaultRollbackPlan())
  },

  setColaborator({ commit }, collaborator) {
    commit('SET_COLLABORATOR', collaborator)
  },
  resetSelectedCollaborator({ commit }) {
    commit('RESET_SELECTED_COLLABORATOR')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
